// TOS Message
<template>
	<div class="tos-mess-main">

		<div class="header wi8_font">
			What I Ate! &nbsp; Terms of Service
			<div class="icon">
				<UniIcon ico="ribbon" color="#369" fit="1"/>
			</div>
		</div>

		<div class="body">
			What I Ate! is intended to be a FUN way to share your dining and food experiences.

			<br/><br/>
			To maintain this intention, What I Ate! reserves the right to remove or edit any submitted content for any reason. 

			<br/><br/>
			YOU MAY NOT submit any sensitive information, personal or otherwise. 
			<br/>
			YOU MAY NOT submit any obscene, defamatory, harassing, or otherwise harmful information.
			<br/>
			YOU MAY NOT submit any copyrighted content, over which you have no authority.
			<br/><br/>
			All content, stories, and images submitted become the property of What I Ate! and Dynamic Arts.
		</div>

	</div>
</template>

<script>
export default {
}
</script>

<style scoped>
.tos-mess-main {
	height: 100%;
	overflow: hidden;
	background-color: #F6F6F6;
	padding: 10px;
	border: solid 0px #090;
}

.header {
	height: 60px;
	overflow: hidden;
	color: #369;
	border: solid 0px #369;
}

.icon {
	float: right;
	width: 48px;
	height: 48px;
	overflow: hidden;
	border: solid 0px #090;		
}

.body {
	color: #000;
	font-size: 15px;
	text-align: justify;
	padding: 0px 20px 20px 0px;
	border: solid 0px #369;
}

</style>
